import React from 'react';
import { Camera, Shirt, Sparkles, X } from 'lucide-react';

interface CreationMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: (action: string) => void;
}

export const CreationMenu: React.FC<CreationMenuProps> = ({ 
  isOpen, 
  onClose, 
  onAction 
}) => {
  if (!isOpen) return null;

  const actions = [
    { 
      key: 'post', 
      title: 'New Drop', 
      description: 'Share your latest fit check', 
      icon: Camera, 
    },
    { 
      key: 'canvas', 
      title: 'Virtual Studio', 
      description: 'Visualize your next outfit', 
      icon: Shirt, 
    },
    { 
      key: 'ai', 
      title: 'Ask Scoop AI', 
      description: 'Get fashion advice & styling tips', 
      icon: Sparkles, 
    },
  ];

  return (
    <div className="fixed inset-0 z-[250] flex flex-col items-center justify-end lg:justify-center p-0 lg:p-6 pointer-events-none">
      
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-md pointer-events-auto animate-in fade-in duration-300" 
        onClick={onClose}
      />
      
      {/* Modal Container */}
      <div className="w-full max-w-md bg-black border-t lg:border border-zinc-800 lg:rounded-2xl rounded-t-[2rem] pointer-events-auto flex flex-col relative shadow-2xl animate-in slide-in-from-bottom lg:zoom-in-95 duration-300 overflow-hidden">
        
        {/* Mobile Drag Handle */}
        <div className="w-full flex justify-center pt-3 pb-1 lg:hidden">
            <div className="w-12 h-1.5 bg-zinc-800 rounded-full"></div>
        </div>

        {/* Header */}
        <div className="p-6 pb-4 border-b border-zinc-800 flex justify-between items-center">
            <h3 className="text-2xl font-black text-white italic uppercase tracking-tighter">Create</h3>
            <button onClick={onClose} className="text-zinc-500 hover:text-white transition-colors hidden lg:block">
                <X size={24} />
            </button>
        </div>

        {/* Action Buttons */}
        <div className="p-6 space-y-4">
          {actions.map((action) => {
            const Icon = action.icon;
            return (
              <button 
                key={action.key}
                onClick={() => {
                  onAction(action.key);
                  onClose(); // Automatically close menu after selecting
                }}
                className="w-full bg-zinc-900/50 border border-zinc-800 p-4 rounded-xl flex items-center gap-5 hover:bg-zinc-900 hover:border-white transition-all group text-left"
              >
                {/* Minimalist Icon Circle */}
                <div className="w-14 h-14 rounded-full bg-black border border-zinc-800 flex items-center justify-center text-zinc-500 group-hover:text-white group-hover:border-white transition-colors shrink-0">
                  <Icon size={24}/>
                </div>
                
                <div>
                  <h3 className="font-black text-white text-sm uppercase tracking-widest mb-1">{action.title}</h3>
                  <p className="text-zinc-500 font-mono text-[10px] uppercase">{action.description}</p>
                </div>
              </button>
            );
          })}
          
          <button 
            onClick={onClose} 
            className="w-full py-5 mt-4 border border-zinc-800 text-zinc-500 font-black text-xs uppercase tracking-[0.2em] hover:text-white hover:border-white transition-colors rounded-xl"
          >
            Cancel
          </button>
        </div>

      </div>
    </div>
  );
};